var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.signed_bankid)?_c('div',[_c('p',[_vm._v("Signed BankID")]),_c('p',[_vm._v(_vm._s(_vm.bankid))])]):_c('div',[_c('BankIDOpenAppComponent',{attrs:{"return_url":`https://test.memlist.se/test/bankid-button`,"intent":'user'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }